<div class="row">
  <div class="col s12">
    <ng-content select="[title]"></ng-content>
    <div class="dashboard-data-progress dashboard-data-progress--column">
      <div
        class="dashboard-data-progress-item dashboard-data-progress-item--column"
        *ngIf="quantity || showZeroQuantity"
      >
        <div class="value">
          {{ quantity | number : '1.0-2' }}
        </div>
        <div>
          {{ units }}
        </div>
      </div>
    </div>
    <div class="col s12 chart-notice" *ngIf="!quantity && !showZeroQuantity">
      {{ 'nouns.empty' | translate }}
    </div>
  </div>
</div>
